export enum RBACAccessLevel {
  read = "read",
  write = "write",
}

export enum RBACDomain {
  allowlist = "allowlist",
  destinationConfiguration = "destinationconfig",
  eventLibrary = "eventlibrary",
  phi = "phi",
  forms = "forms",
  auditLog = "auditlog",
  webTrackerMonitoring = "wtm",
  analytics = "analytics",
  offlineAttributions = "offlineattributions",
  product = "product",
  video = "video",
  audiences = "audiences",
  consentManagement = "consentmanagement",
}

export type RolePermissions = {
  [role: string]: {
    [domain: string]: string[];
  };
};

export type FormSubmissionAccess = {
  all: boolean;
  form_ids: string[];
};
